import { render } from "./Dictionaries.vue?vue&type=template&id=5d9bad15&scoped=true"
import script from "./Dictionaries.vue?vue&type=script&lang=js"
export * from "./Dictionaries.vue?vue&type=script&lang=js"

import "./Dictionaries.vue?vue&type=style&index=0&id=5d9bad15&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9bad15"],['__file',"src/views/h5/common/basedata/dictionary/Dictionaries.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d9bad15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d9bad15', __exports__)) {
    api.reload('5d9bad15', __exports__)
  }
  
  module.hot.accept("./Dictionaries.vue?vue&type=template&id=5d9bad15&scoped=true", () => {
    api.rerender('5d9bad15', render)
  })

}


export default __exports__